import { useSelector } from 'react-redux';
import { useSearchParams } from 'hooks/useSearchParams';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import userRoles from 'constants/userRoles';
import { useUserId } from 'components/EmployeeDetails/BankAccountDetails/hooks/useUserId';
import useEmployeeVpfData from './useEmployeeVpfData';
import useFetchPayDetailsData from '../useFetchPayDetailsData';

export const useVPF = () => {
  
  const { urlParams } = useSearchParams();
  const userId = urlParams.get('userId');
  const loggedInUserId = useSelector(loggedInUserSelectors.peopleId);
  const isAdmin = useSelector(loggedInUserSelectors.role) === userRoles.ADMIN;
  const peopleId = String(useUserId());
  
  const { firstName } = useFetchPayDetailsData(peopleId);
  const { vpfData, onVPFOptIn, onVPFOptOut } = useEmployeeVpfData({ peopleId });
  const currentOrganization = useSelector(loggedInUserSelectors.currentOrganization);
  const allowEmployeesToUpdateVpf = currentOrganization?.paymentOptions?.allowEmployeesToUpdateVpf;


  const vpfNode = {
    id: 'vpf',
    componentName: 'Voluntary PF',
    monthlyAmount: vpfData?.vpfAmount || 0,
  };

  // Employee can manage their own VPF OR Admin can manage any employee's VPF
  const canManageVPF = (!userId || userId === String(loggedInUserId)) || (userId && isAdmin);

const shouldManageVPF = Boolean(
  vpfNode.monthlyAmount > 0 && 
  allowEmployeesToUpdateVpf &&
  canManageVPF
);

  
  const isVPFActive = vpfNode.monthlyAmount > 0;
  const isVPFDisabled = !isAdmin && !allowEmployeesToUpdateVpf;

  return {
    // User data
    firstName,
    isAdmin,
    peopleId,
    
    // VPF data
    vpfData,
    vpfNode,
    isVPFActive,
    isVPFDisabled,
    shouldManageVPF,
    
    // Actions
    onVPFOptIn,
    onVPFOptOut,
  };
};

export default useVPF; 